var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0AA2C0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.527 41.1818H55.0043L75.7315 91.7727H76.5497L97.277 41.1818H112.754V111H100.618V63.0341H99.9702L80.6747 110.795H71.6065L52.3111 62.9318H51.6634V111H39.527V41.1818ZM126.527 111V41.1818H152.709C158.072 41.1818 162.572 42.1818 166.209 44.1818C169.868 46.1818 172.629 48.9318 174.493 52.4318C176.379 55.9091 177.322 59.8636 177.322 64.2955C177.322 68.7727 176.379 72.75 174.493 76.2273C172.607 79.7045 169.822 82.4432 166.141 84.4432C162.459 86.4205 157.925 87.4091 152.538 87.4091H135.186V77.0114H150.834C153.97 77.0114 156.538 76.4659 158.538 75.375C160.538 74.2841 162.016 72.7841 162.97 70.875C163.947 68.9659 164.436 66.7727 164.436 64.2955C164.436 61.8182 163.947 59.6364 162.97 57.75C162.016 55.8636 160.527 54.3977 158.504 53.3523C156.504 52.2841 153.925 51.75 150.766 51.75H139.175V111H126.527ZM186.365 98.0455V87.9886L215.99 41.1818H224.376V55.5H219.263L199.32 87.1023V87.6477H240.672V98.0455H186.365ZM219.672 111V94.9773L219.808 90.4773V41.1818H231.74V111H219.672Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_1139)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 250,
    width: 157,
    height: 138,
    fill: "#FAFAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 194C167.914 194 112 249.907 112 319C112 388.087 167.906 444 237 444C306.087 444 362 388.093 362 319C362 249.913 306.093 194 237 194ZM282.038 332.876L223.301 366.815C218.346 369.678 212.236 369.683 207.272 366.819C202.312 363.957 199.257 358.666 199.257 352.939V285.061C199.257 279.334 202.313 274.043 207.272 271.181C209.751 269.75 212.517 269.035 215.283 269.035C218.052 269.035 220.821 269.752 223.301 271.185L282.039 305.124C286.994 307.987 290.046 313.276 290.046 319C290.046 324.724 286.994 330.012 282.038 332.876Z",
    fill: "#0AA2C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1139",
    x: 27.5273,
    y: 41.1836,
    width: 217.145,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_1139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white",
    transform: "translate(112 194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp4);
export default __webpack_public_path__ + "static/media/mp4.6157a9e524001500517b9aa1b27950fe.svg";
export { ForwardRef as ReactComponent };